"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ThemeProvider = _interopRequireDefault(require("../style/ThemeProvider"));
var _theme = _interopRequireDefault(require("../style/theme"));
/*:: import { type ThemeType } from '../style/ThemeTypes';*/
/*:: type Props = {
  theme: ThemeType
};*/
var MockedThemeProvider = function MockedThemeProvider(props /*: Props*/) {
  return /*#__PURE__*/_react.default.createElement(_ThemeProvider.default, props);
};
MockedThemeProvider.displayName = 'MockedThemeProvider';
MockedThemeProvider.defaultProps = {
  theme: _theme.default
};
var _default = exports.default = MockedThemeProvider;
//# sourceMappingURL=MockedThemeProvider.js.map